import { CatalogEntry } from '@/types/prismic'
import prismicService from './prismicService'
import apiCalls from '@/helpers/apiCall'
import api from '@/helpers/api'

const loadAppData = async (forAccount: boolean) => {
  let zuoraAppCatalogTask = null

  const prismicAppCatalogTask = prismicService.getAppCatalog()

  if (forAccount)
    zuoraAppCatalogTask = apiCalls.get(api.AccountAppCatalog, '', '')
  else zuoraAppCatalogTask = apiCalls.get(api.AppCatalog, '', '')

  const [prismicCatalog, { data: zuoraCatalog }] = await Promise.all([
    prismicAppCatalogTask,
    zuoraAppCatalogTask
  ])

  return {
    prismicCatalog,
    zuoraCatalog
  }
}

const toLibraryApp = ({
  zuoraApp,
  prismicCatalog
}: {
  zuoraApp: ZuoraLibraryApp
  prismicCatalog: CatalogEntry[]
}): LibraryApp => {
  const prismicAppInfo = prismicCatalog.find(
    prismicApp => prismicApp.externalKey === zuoraApp.id
  )
  const name = prismicAppInfo?.title || zuoraApp.name
  const description = prismicAppInfo?.description || ''

  return {
    id: zuoraApp.id,
    name,
    description,
    iconUrl: prismicAppInfo?.iconActiveUrl || '',
    title: prismicAppInfo?.descriptionShort || '',
    isActive: zuoraApp.isActive,
    searchKeywords: `${name} ${description}`.removeDiacritics()
  }
}

export default {
  getAppsForPack: async (packSku: string): Promise<LibraryApp[]> => {
    const { prismicCatalog, zuoraCatalog } = await loadAppData(false)

    if (!zuoraCatalog?.length) return []

    const appList = zuoraCatalog
      .filter((zuoraApp: ZuoraLibraryApp) => {
        return zuoraApp.packSku == packSku
      })
      .map(
        (zuoraApp: ZuoraLibraryApp): LibraryApp => {
          return toLibraryApp({
            zuoraApp,
            prismicCatalog
          })
        }
      )

    return appList
  },
  getAccountApps: async (): Promise<LibraryApp[]> => {
    const { prismicCatalog, zuoraCatalog } = await loadAppData(true)

    if (!zuoraCatalog?.length) return []

    const appList = zuoraCatalog.map(
      (zuoraApp: ZuoraLibraryApp): LibraryApp =>
        toLibraryApp({
          zuoraApp,
          prismicCatalog
        })
    )

    return appList
  }
}
